import { buildProps } from '@lit-element/utils'
import type { ExtractPropTypes, PropType } from 'vue'
import type TimeAgo from './time-ago.vue'

export const timeAgoProps = buildProps({
  /**
   * @description 时间
   */
  datetimes: {
    type: [Array, String, Number] as PropType<
      Array<number | string> | string | number
    >,
    default: () => Date.now(),
  },
  /**
   * @description 更新时间的间隔（毫秒）
   */
  interval: {
    type: Number as PropType<number>,
    default: 10000, // 默认值为 10 秒
  },
} as const)

export type TimeAgoProps = ExtractPropTypes<typeof timeAgoProps>
export type TimeAgoPropsInstance = InstanceType<typeof TimeAgo>
